import { APPLICATION_ROUTES } from '@philips-emr/hpms-provider-accreditation-commons';
import TokenConstants from '@philips-emr/hpms-provider-accreditation-commons/lib/constants/token-constants';
import { ThemeTonalRange } from '@philips-emr/tws-constants';
import Controller, { OnMount } from '@philips-emr/tws-core/lib/client';
import { AuthenticationService, ThemeService } from '@philips-emr/tws-core/lib/services';
import { applicationContext, OpenModuleOptions } from '@philips-emr/tws-foundation/lib/context';

import BaseController from './BaseController';

@Controller({ fragment: 'redirect' })
export default class RedirectControler extends BaseController {

  @OnMount({ target: 'panel-redirect' })
  onMount(): void {
    ThemeService.setContentTonalRange(ThemeTonalRange.ULTRA_LIGHT);
    applicationContext.clearNavigationStack();

    const token = AuthenticationService.getJWTToken();
    const nrSeqUser = token ? token.claims[TokenConstants.NR_SEQ_USER] as string : '';

    this.historyService.push(APPLICATION_ROUTES.PROVIDER_ACCREDITATION, { nrSeqUser });

    const openModuleOptions: OpenModuleOptions = {
      at: {
        params: { nrSeqUser },
        path: APPLICATION_ROUTES.PROVIDER_ACCREDITATION,
      },
    };
    applicationContext.openModule('accreditation', openModuleOptions);
    applicationContext.openModule('technical-visit', { preventNavigation: true });
    applicationContext.openModule('negotiation', { preventNavigation: true });
    applicationContext.openModule('calls', { preventNavigation: true });
  }
}
